export const RADII = {
  xs: { value: '2px' },
  sm: { value: '4px' },
  md: { value: '6px' },
  lg: { value: '8px' },
  xl: { value: '10px' },
};
